<template>
  <UtilImgBackground :url="url" class="relative overflow-hidden border cursor-pointer" @click="$emit('click')">
    <div
      v-if="isVideo"
      class="absolute flex items-center justify-center w-full h-full text-white bg-black bg-opacity-40"
    >
      <button
        class="w-20 h-20 text-4xl text-white bg-black rounded-full cursor-pointer bg-opacity-40 hover:bg-opacity-80"
      >
        <FontAwesomeIcon :icon="faPlay" class="ml-1" />
      </button>
    </div>
    <slot />
  </UtilImgBackground>
</template>

<script>
import { faPlay } from '@fortawesome/pro-solid-svg-icons'
import UtilImgBackground from './UtilImgBackground.vue'

import BridgeApi from '@/lib/api/bridge'
// You must provide these helpers and API handler in your Vue 2 app
import { getFileType, formatMapImageUrl, formatImgixUrl, formatVideoImageUrl } from '@/lib/file/file'

export default {
  name: 'UtilListingGalleryThumbnail',
  components: {
    UtilImgBackground
  },
  props: {
    item: { type: Object }
  },
  data() {
    return {
      fileApi: new BridgeApi(),
      file: null,
      faPlay
    }
  },
  computed: {
    type() {
      return getFileType(this.item)
    },
    url() {
      if (this.fileApi.isLoading) {
        return null
      }

      if (this.isVideo) {
        return formatVideoImageUrl(this.file)
      }

      if (this.item.src) {
        return this.item.src
      }

      if (!this.type) {
        const { region, country } = this.item
        return formatMapImageUrl({ region, country })
      } else if (this.type.includes('image')) {
        return formatImgixUrl(this.item)
      } else {
        return formatVideoImageUrl(this.file)
      }
    },
    isVideo() {
      return this.item?.type?.includes('video')
    }
  },
  methods: {
    async getFile() {
      const { fileRef } = this.item

      if (this.isVideo && this.fileApi) {
        await this.fileApi.get(`/v1/files/${fileRef}`)

        if (this.fileApi.data) {
          const { readyToStream } = this.fileApi.data
          this.file = this.fileApi.data

          if (readyToStream === false) {
            setTimeout(() => {
              this.getFile()
            }, 5000)
          }
        }
      }
    }
  },
  mounted() {
    this.getFile()
  }
}
</script>
